export const BL_FRONTEND_LIB = 'blfrontend';
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export function createBlSvelteComponent({ componentName, target, props, }) {
    if (!window?.[BL_FRONTEND_LIB]?.[componentName]) {
        throw new Error(`window.${BL_FRONTEND_LIB}.${componentName} could not be found. Are you sure you have included ${BL_FRONTEND_LIB}.lib.cjs in your project.`);
    }
    return new window[BL_FRONTEND_LIB][componentName]({ target, props });
}
export var SvelteService;
(function (SvelteService) {
    SvelteService["SnackBarService"] = "snackBarService";
    SvelteService["TabsService"] = "tabsService";
    SvelteService["TranslationsService"] = "translationsService";
    SvelteService["MfeService"] = "mfeService";
    SvelteService["ModalsService"] = "modalsService";
    SvelteService["ScreenService"] = "screenService";
    SvelteService["UniqueIdService"] = "uniqueIdService";
})(SvelteService || (SvelteService = {}));
export function getSvelteService(service) {
    if (!window?.[BL_FRONTEND_LIB]?.[service]) {
        throw new Error(`window.${BL_FRONTEND_LIB}.${service} could not be found. Are you sure you have included ${BL_FRONTEND_LIB}.lib.cjs in your project.`);
    }
    return window[BL_FRONTEND_LIB][service];
}
